import { render } from "./shop_sells_trends.vue?vue&type=template&id=66248aed&scoped=true"
import script from "./shop_sells_trends.vue?vue&type=script&lang=js"
export * from "./shop_sells_trends.vue?vue&type=script&lang=js"

import "./shop_sells_trends.vue?vue&type=style&index=0&id=66248aed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66248aed"]])

export default __exports__